import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const EvtRltdBrandItem = styled.div`
  width: 100%;

  &.type-square {
    .btn {
      padding: 13px 32px 13px 20px;
      justify-content: flex-start;
      border: 1px solid rgba(0, 0, 0, 0.08);

      .img {
        width: 34px;
        height: 34px;
        margin-right: 10px;
      }

      .text {
        max-width: 230px;
      }

      svg {
        position: absolute;
        top: 50%;
        right: 20px;
        margin-top: -8px;
      }
    }
  }

  &.type-round {
    width: 110px;
    min-width: unset !important;
    max-width: unset !important;
    height: auto;

    .btn {
      flex-direction: column;

      .img {
        width: 90px;
        height: 90px;
        margin-bottom: 10px;
      }

      .text {
        -webkit-line-clamp: 2;
      }
    }
  }

  &.type-square2 {
    .btn {
      width: 100%;
      justify-content: flex-start;
      padding: 6px 20px 12px;
      text-align: left;

      .img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 12px;
        flex-shrink: 0;
      }

      .brand-name {
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
        padding-top: 1px;
      }

      .brand-name-en {
        font-size: 12px;
        line-height: 16px;
        color: #999;
      }
    }

    &.bg-type-black {
      .btn {
        .brand-name {
          color: #fff;
        }

        .brand-name-en {
          color: #777;
        }
      }
    }
  }

  .btn {
    position: relative;
    width: 100%;

    &.white,
    &.transparencyBlack {
      .text {
        color: #000;
      }
    }

    &.black,
    &.transparencyWhite {
      .text {
        color: #fff;
      }
    }

    .img {
      border-radius: 50%;
    }

    .text {
      font-size: 14px;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    &.type-square {
      .btn {
        padding: ${mixin.pxToVw('13 32 13 20')};

        .img {
          width: ${mixin.pxToVw('34')};
          height: ${mixin.pxToVw('34')};
          margin-right: ${mixin.pxToVw('10')};
        }

        .text {
          max-width: ${mixin.pxToVw('230')};
        }

        svg {
          right: ${mixin.pxToVw('20')};
          margin-top: ${mixin.pxToVw('-8')};
        }
      }
    }

    &.type-square2 {
      .btn {
        padding: ${mixin.pxToVw('6 20 12')};

        .img {
          width: ${mixin.pxToVw('40')};
          height: ${mixin.pxToVw('40')};
          margin-right: ${mixin.pxToVw('12')};
        }

        .brand-name {
          font-size: ${mixin.pxToVw('16')};
          line-height: ${mixin.pxToVw('22')};
        }

        .brand-name-en {
          font-size: ${mixin.pxToVw('12')};
          line-height: ${mixin.pxToVw('16')};
        }
      }
    }

    &.type-round {
      width: ${mixin.pxToVw('110')};

      .btn {
        .img {
          width: ${mixin.pxToVw('90')};
          height: ${mixin.pxToVw('90')};
          margin-bottom: ${mixin.pxToVw('10')};
        }
      }
    }

    .btn {
      .text {
        font-size: ${mixin.pxToVw('14')};
      }
    }
  }

  @media ${({ theme }) => theme.media.xl} {
    &.type-square {
      width: 400px;

      .btn {
        padding: 13px 42px 13px 20px;

        .img {
          width: 50px;
          height: 50px;
          margin-right: 10px;
        }

        .text {
          max-width: 278px;
          font-size: 17px;
        }

        svg {
          right: 20px;
          margin-top: -6px;
        }
      }
    }

    &.type-square2 {
      .btn {
        padding: 0;
        align-items: flex-start;

        .img {
          display: none;
        }

        .text {
          text-overflow: clip;
          overflow: visible;
          -webkit-line-clamp: initial;
          -webkit-box-orient: initial;
          -webkit-box-align: initial;
          word-break: normal;
          overflow-wrap: normal;
        }

        .brand-name {
          font-size: 40px;
          line-height: 120%;
          margin-bottom: 8px;
        }

        .brand-name-en {
          font-size: 16px;
          line-height: 135%;
        }
      }
    }

    &.type-round {
      width: 160px;

      .btn {
        .img {
          width: 160px;
          height: 160px;
          margin-bottom: 10px;
        }

        .text {
          font-size: 16px;
          line-height: 130%;
        }
      }
    }
  }
`;
